var _dec, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { inject, observer } from 'mobx-react';

import { fieldValue } from 'sdc-data-models';

export var CheckboxFieldEditor = (_dec = inject('editingStore'), _dec(_class = observer(_class = function (_React$Component) {
  _inherits(CheckboxFieldEditor, _React$Component);

  function CheckboxFieldEditor() {
    _classCallCheck(this, CheckboxFieldEditor);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  CheckboxFieldEditor.prototype.render = function render() {
    var _props = this.props,
        store = _props.editingStore,
        field = _props.field,
        locale = _props.locale;

    return React.createElement('input', { type: 'checkbox', checked: !!fieldValue(store._sending, field.key),
      onChange: store.updateField(field, locale, true)
    });
  };

  return CheckboxFieldEditor;
}(React.Component)) || _class) || _class);